export default [
  {
    path: "/inventory",
    name: "INVENTORY_TITLE",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "INVENTORY_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "InventoryView" */ "./InventoryView.vue")
  },
  {
    path: "/inventory/details/:inventoryId",
    name: "INVENTORY_DETAILS_TITLE",
    props: true, // to be able receiving ':id'
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "INVENTORY_DETAILS_TITLE"
    },

    component: () =>
      import(/* webpackChunkName: "InventoryDetailView" */ "./InventoryDetailView.vue")
    },
    {
      path: "/inventory/report",
      name: "INVENTORY_REPORT_TITLE",
      meta: {
        permissions: {
          roles: ["office", "administrator", "superadmin"],
          redirectTo: "/401"
        },
        title: "INVENTORY_REPORT_TITLE"
      },
      component: () =>
        import(/* webpackChunkName: "InventoryReportView" */ "./InventoryReportView.vue")
    },
    {
      path: "/inventory/sync",
      name: "SYNC_TITLE",
      meta: {
        permissions: {
          roles: ["office", "administrator", "superadmin"],
          redirectTo: "/401"
        },
        title: "SYNC_TITLE"
      },
      component: () =>
        import(/* webpackChunkName: "MobileSyncView" */ "./MobileSyncView.vue")
    }
];
